import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import "./servicios.scss"

export const SkolServiciosSection = () => {
  return (
    <>
      <section
        className="servicios-skol-solutions-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <div className="servicios-skol-solutions-title-container">
          <h2>
            Servicios de <span>Skol Solutions</span>
          </h2>
        </div>
        <div className="servicios-skol-solutions-info-container">
          <div className="servicios-skol-solutions-info-text">
            <p>
              <span>Skol Solutions </span>
              es una empresa de Proyectos audiovisuales, Comunicaciones,
              Multimedia y servicios, que ofrece soluciones integrales de
              vanguardia en la integración de sistemas audiovisuales, en todos
              los ámbitos de aplicaciones: hoteles, hospitales, oficinas,
              laboratorios, centros lúdicos culturales o educativos, museos,
              industria, etc.
            </p>
          </div>
          <div className="servicios-skol-solutions-info-image">
            <StaticImage
              src="../../../../images/servicios/landing/tecnologia.png"
              alt="portada-servicios"
              placeholder="blurred"
            />
          </div>
        </div>
      </section>
    </>
  )
}
